// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1GssG","left":"InfoRow_left__1fVes"};